import { Brain, Target, BookOpen, Zap, Lightbulb, Trophy } from 'lucide-react'

export const services = [
  {
    id: 1,
    title: 'Mathématiques Mentales Appliquées',
    description: 'Développez des capacités exceptionnelles de calcul mental grâce à des techniques éprouvées et des exercices progressifs adaptés à tous les niveaux.',
    icon: Brain,
    image: 'https://images.unsplash.com/photo-1509228468518-180dd4864904?w=800&q=80',
    features: [
      'Techniques de calcul rapide',
      'Méthodes de mémorisation',
      'Exercices progressifs',
      'Suivi personnalisé'
    ]
  },
  {
    id: 2,
    title: 'Coaching en Performance et Concentration',
    description: 'Optimisez votre concentration et vos performances grâce à des méthodes scientifiques de coaching mental et de gestion du stress.',
    icon: Target,
    image: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=800&q=80',
    features: [
      'Techniques de concentration',
      'Gestion du stress',
      'Optimisation des performances',
      'Exercices pratiques'
    ]
  },
  {
    id: 3,
    title: 'Coaching Scolaire et Éducatif',
    description: 'Accompagnement personnalisé pour améliorer les résultats scolaires, développer des méthodes de travail efficaces et renforcer la confiance en soi.',
    icon: BookOpen,
    image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&q=80',
    features: [
      'Méthodologie de travail',
      'Organisation et planification',
      'Préparation aux examens',
      'Soutien motivationnel'
    ]
  },
  {
    id: 4,
    title: 'Coaching en Apprentissage - Neurolearning',
    description: 'Exploitez le potentiel de votre cerveau avec des techniques basées sur les neurosciences pour un apprentissage optimal et durable.',
    icon: Zap,
    image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&q=80',
    features: [
      'Techniques neuroscientifiques',
      'Optimisation de la mémoire',
      'Apprentissage accéléré',
      'Plasticité cérébrale'
    ]
  },
  {
    id: 5,
    title: 'Cours de Soutien',
    description: 'Cours particuliers et en petits groupes dans toutes les matières pour combler les lacunes et exceller dans vos études.',
    icon: Lightbulb,
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80',
    features: [
      'Toutes matières',
      'Tous niveaux',
      'Approche personnalisée',
      'Résultats garantis'
    ]
  },
  {
    id: 6,
    title: 'Coaching Cognitif et Mental',
    description: 'Développez vos capacités cognitives globales : mémoire, logique, créativité et résolution de problèmes grâce à un entraînement ciblé.',
    icon: Trophy,
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80',
    features: [
      'Entraînement cognitif',
      'Développement de la mémoire',
      'Stimulation intellectuelle',
      'Exercices ludiques'
    ]
  }
]

export const formations = [
  {
    id: 1,
    title: 'Programme Genius Kids',
    category: 'Enfants 6-12 ans',
    description: 'Programme ludique et éducatif pour développer les capacités mentales des enfants à travers des jeux et exercices adaptés.',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80',
    duration: '3 mois',
    level: 'Débutant',
    price: '299€',
    objectives: [
      'Développer le calcul mental',
      'Améliorer la concentration',
      'Renforcer la confiance en soi'
    ]
  },
  {
    id: 2,
    title: 'Programme Genius Teen',
    category: 'Adolescents 13-18 ans',
    description: 'Formation intensive pour les adolescents visant l\'excellence scolaire et le développement de compétences cognitives avancées.',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80',
    duration: '6 mois',
    level: 'Intermédiaire',
    price: '599€',
    objectives: [
      'Optimiser les performances scolaires',
      'Maîtriser les techniques de mémorisation',
      'Préparer les examens'
    ]
  },
  {
    id: 3,
    title: 'Programme Genius Adult & Adolescence',
    category: 'Adultes & Adolescence',
    description: 'Programme complet pour adultes souhaitant développer leurs capacités cognitives et maintenir leur agilité mentale.',
    image: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=800&q=80',
    duration: '4 mois',
    level: 'Tous niveaux',
    price: '499€',
    objectives: [
      'Entretenir la mémoire',
      'Améliorer la concentration',
      'Développer l\'agilité mentale'
    ]
  },
  {
    id: 4,
    title: 'Formation Neurolearning',
    category: 'Spécialisée',
    description: 'Formation avancée basée sur les neurosciences pour maîtriser les techniques d\'apprentissage les plus efficaces.',
    image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&q=80',
    duration: '8 semaines',
    level: 'Avancé',
    price: '799€',
    objectives: [
      'Comprendre le fonctionnement du cerveau',
      'Maîtriser les techniques neuroscientifiques',
      'Optimiser l\'apprentissage'
    ]
  },
  {
    id: 5,
    title: 'Coaching Performance',
    category: 'Professionnel',
    description: 'Coaching personnalisé pour professionnels visant l\'excellence et la haute performance dans leur domaine.',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80',
    duration: '3 mois',
    level: 'Tous niveaux',
    price: '899€',
    objectives: [
      'Optimiser les performances professionnelles',
      'Gérer le stress et la pression',
      'Développer le leadership'
    ]
  },
  {
    id: 6,
    title: 'Préparation Concours & Entretien',
    category: 'Examens',
    description: 'Programme intensif de préparation aux concours et examens avec méthodologie éprouvée et suivi personnalisé.',
    image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&q=80',
    duration: '6 mois',
    level: 'Intermédiaire',
    price: '699€',
    objectives: [
      'Maîtriser les épreuves',
      'Gérer le temps et le stress',
      'Maximiser les résultats'
    ]
  }
]

export const videos = [
  {
    id: 1,
    title: 'Découvrez GENIUS CLUB',
    description: 'Présentation complète de notre centre et de nos méthodes pédagogiques innovantes.',
    category: 'Présentation',
    thumbnail: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80',
    duration: '3:45',
    videoUrl: 'WhatsApp Vidéo 2025-10-16 à 14.33.28_e427de46.mp4'
  },
  {
    id: 2,
    title: 'Témoignage - Sarah, 15 ans',
    description: 'Sarah partage son expérience et ses progrès remarquables après 6 mois de formation.',
    category: 'Témoignage',
    thumbnail: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80',
    duration: '2:30',
    videoUrl: 'WhatsApp Vidéo 2025-10-16 à 14.33.39_56b1b0e2.mp4'
  },
  {
    id: 3,
    title: 'Techniques de Calcul Mental',
    description: 'Démonstration de techniques avancées de calcul mental par nos formateurs experts.',
    category: 'Tutoriel',
    thumbnail: 'https://images.unsplash.com/photo-1509228468518-180dd4864904?w=800&q=80',
    duration: '5:20',
    videoUrl: 'WhatsApp Vidéo 2025-10-16 à 14.33.39_e9da5d6e.mp4'
  }
 
]

export const motivationalQuotes = [
  {
    id: 1,
    quote: 'L\'intelligence n\'est pas la capacité de stocker des informations, mais de savoir où les trouver.',
    author: 'Albert Einstein',
    role: 'Physicien théoricien'
  },
  {
    id: 2,
    quote: 'Le génie, c\'est 1% d\'inspiration et 99% de transpiration.',
    author: 'Thomas Edison',
    role: 'Inventeur'
  },
  {
    id: 3,
    quote: 'L\'éducation est l\'arme la plus puissante pour changer le monde.',
    author: 'Nelson Mandela',
    role: 'Leader politique'
  },
  {
    id: 4,
    quote: 'Celui qui déplace une montagne commence par déplacer de petites pierres.',
    author: 'Confucius',
    role: 'Philosophe'
  },
  {
    id: 5,
    quote: 'Le succès n\'est pas final, l\'échec n\'est pas fatal : c\'est le courage de continuer qui compte.',
    author: 'Winston Churchill',
    role: 'Premier ministre'
  }
]